import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@app/environment';
import { NoticeService } from '@app/services/notice.service';
import { TimeoutCheckService } from '@app/services/timeout-check.service';
import { Common } from '@app/utils/common';
import { firstValueFrom } from 'rxjs';
import * as AS from '../auth-storage';

interface UserInfo {
  accessToken: string;
  idToken: string;
  refreshToken: string;
  depot: string;
  spid: string;
  username: string;
  role: string;
}

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  private readonly http = inject(HttpClient);
  private readonly notice = inject(NoticeService);
  private readonly router = inject(Router);
  private readonly timeoutCheck = inject(TimeoutCheckService);

  async authenticate(token: string) {
    const data = { auth: token }
    let res: UserInfo | null = null;
    try {
      res = await firstValueFrom(this.http.post<UserInfo>(environment.apiUrl + '/checkLogin', data,));
      AS.setIdToken(res.idToken);
      AS.setUserDepot(res.depot);
      AS.setUserSpid(res.spid);
      AS.setUsername(res.username);
      AS.setUserRole(res.role);
    } catch {
      this.notice.toast('Authentication failed. Please log in again.', 'error');
      this.timeoutCheck.stopTimer();
      Common.logout(this.router);
    }
  }

  // 清除所有令牌
  clearTokens() {
    AS.clear();
  }
}
